var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('fragment', [typeof _vm.author === 'string' ? _c('em', {
    staticClass: "author_repre"
  }, [_vm._v(_vm._s(_vm.author))]) : [_c('em', {
    staticClass: "author_writing"
  }, [_vm._v(_vm._s(_vm.getTypeText(_vm.author.type)))]), _c('em', {
    staticClass: "author_name"
  }, [_vm._v(_vm._s(_vm.author.name))])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }